<section class="hero-container">
  <!-- TODO: Need to refactor fl-nav-container out from hero-container in order to be reused by different landing pages -->
  <!-- Preferably separate nav menu item rendering logic into different variables -->
  <!-- Current implementation using Input() couples our components-->
  <fl-nav-container [showSecondaryNavButtons]="showSecondaryNavButtons && !isSvbPage"></fl-nav-container>
  <div class="textures">
    <img src="assets/solutions/solutions--txtr-why-flow-lower.svg" alt="" class="lower" />
    <img src="assets/solutions/solutions--txtr-why-flow-lower.svg" alt="" class="upper" />
  </div>
  <div class="hero-content" [class.without-mobile-subheadings]="hideSubheadersOnMobile">
    <header *ngIf="subheadings">
      <h1>{{ header }}</h1>
      <h3 *ngFor="let heading of subheadings">{{ heading }}</h3>
    </header>
    <h1 *ngIf="!subheadings">{{ header }}</h1>
    <a [href]="href" (click)="onScrollToRequestDemo($event)" class="button" *ngIf="showCTAButton">{{ isSvbPage ? 'Contact Us' : 'Contact Sales' }}</a>
    <img data-testid="hero-illustration" src="{{ heroIllustration }}" alt="" />
  </div>
  <div *ngIf="foldText && !isSvbPage" class="organizations-fold-text-container">
    <p>{{ foldText }}</p>
  </div>
</section>
